import { MenuItem as MuiMenuItem } from '@mui/material';
import type { MenuItemProps as MuiMenuItemProps } from '@mui/material/MenuItem';
import type { SxProps, Theme } from '@mui/material/styles';

export type MenuItemProps = MuiMenuItemProps;

export const MenuItem = ({ sx, ...rest }: MenuItemProps): JSX.Element => {
  const baseSx: SxProps<Theme> = (theme) => ({
    fontSize: '13px',
    lineHeight: 1.4,
    paddingX: theme.app.spacing.xxs,
    '& .MuiTypography-root, & span': {
      fontSize: '13px',
      lineHeight: 1.4,
    },
  });
  const resolvedSx = sx ? [baseSx, ...(Array.isArray(sx) ? sx : [sx])] : baseSx;
  return <MuiMenuItem sx={resolvedSx} {...rest} />;
};
